<template>
    <div class="bg-groups ar-container">
        <client-only>
            <model-viewer
                class="c-model-viewer position-relative"
                :style="{height: height}"
                autoplay
                :animation-name="animationName"
                :poster="props.designUrl"
                :src="props.designUrl"
                exposure="2"
                shadowIntensity="0"
                shadowSoftness="0"
                ar
                ar-modes="scene-viewer web-xr quick-look"
                camera-controls
                touch-action="pan-x pan-y"
                alt="A 3D model carousel"
            >
                <button
                    class="position-absolute btn btn-white bg-venus m-3 px-3"
                    @click.prevent="toggleAnimation"
                    v-if="animationArray.length > 1"
                >
                    <span class="fw-bolder text-white outline-none">
                        <i class="fa fa-dropbox"></i>
                        {{
                            buttonText
                        }}
                    </span>
                </button>
                <button
                    class="position-absolute right-0 btn btn-white bg-venus m-3 px-3"
                    style="right: 0 !important"
                    v-if="props.designUrl.length && screenWidth > 991"
                    @click="$emit('openQrModal', true)"
                >
                    <span class="fw-bolder text-white outline-none">
                        <img class="bg-text-img" src="/images/ar-white.svg" style="width: 30px" alt="" v-if="!isAr" />
                        View in your space
                    </span>
                </button>
                
                <button
                    slot="ar-button"
                    id="ar-button"
                    v-else-if="props.designUrl.length && screenWidth <= 991"
                >
                    View in your space
                </button>

                <div id="button-load" slot="poster">
                    <span
                        v-if="props.designUrl.length > 0"
                        style="
                            display: flex;
                            justify-content: space-evenly;
                            align-items: center;
                        "
                    >
                        <Spinner
                            :active="true"
                            :is-full-page="false"
                            name="circle"
                            color="white"
                            class="vld-parent"
                            width="30px"
                        />
                        Loading 3D Model...
                    </span>
                    <span v-else> No 3D Model </span>
                </div>

                <div id="ar-prompt">
                    <img style="height: 10px" src="/icons/hand.jpg" />
                </div>
            </model-viewer>
        </client-only>
    </div>
</template>

<script setup>
import { ref, computed, watch, onMounted } from "vue";
import '@google/model-viewer';

const props = defineProps({
    designUrl: {
        type: String,
        required: true,
    },
    height: {
        type: String,
        default: "60vh"
    }
});
const screenWidth = ref(screen.width);
const isRoomModeActive = ref(true);
const animationArray = ref([]);
const showAnimation = ref(false);
const buttonText = ref("Open");
const animationName = ref("");
// const animationName = ref("Door_close");
const environmentImage = ref("");

const roomView = async () => {
    isRoomModeActive.value = !isRoomModeActive.value;
};

const modelImg = computed(() => {
    if (process.client) {
        let host = "";
        host = window.location.host;
        return `http://${host}/glb/DIL-DSB-101.glb`;
    }
});

const toggleAnimation = () => {
    showAnimation.value = !showAnimation.value;
    let closeAnimation = animationArray.value.filter((i) =>
        i.includes("_close")
    );
    let openAnimation = animationArray.value.filter((i) => i.includes("_Open"));
    if (showAnimation.value)
        animationName.value = openAnimation.length ? openAnimation[0] : "";
    else animationName.value = closeAnimation.length ? closeAnimation[0] : "";

    buttonText.value = showAnimation.value ? "Close" : "Open";
};

watch(
    animationName,
    (newVal) => {
        if (process.client) {
            const modelViewer = document.querySelector("model-viewer");
            if (newVal === "Door_Open") {
                modelViewer.play();
                setTimeout(() => {
                    modelViewer.play({
                        repetitions: 1, // Set the number of repetitions
                        pingpong: false, // Set pingpong to true/false as needed
                    });
                });
            }
            
        }
        
    },
    { immediate:true, deep: true }
);

onMounted(() => {
    setTimeout(() => {
        if (process.client) {
            const modelViewer = document.querySelector("model-viewer");
            modelViewer.addEventListener("load", () => {
                const names = modelViewer.availableAnimations;
                if (names.length) {
                    animationArray.value = names;
                    if (names.length >= 1 && names[0] != "No_Mirror") {
                        environmentImage.value = "/images/3d/Studio_Lightbox.hdr";
                    }
                }
            });
        }
    });
});
</script>

<style lang="scss">
#button-load {
    background-image: url("../../assets/ic_get_app_white_24dp.svg");
    background-repeat: no-repeat;
    background-color: #000;
    color: white;
    cursor: pointer;
    border-radius: 6px;
    display: inline-block;
    padding: 10px 15px;
    font-weight: 500;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.2), 0 0 4px rgba(0, 0, 0, 0.25);
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate3d(-50%, -50%, 0);
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: center;

    span:first-child {
        flex-direction: row;
    }
}

@media screen and (max-width: 484px) {
    #button-load {
        font-size: 12px;

        span:first-child {
            flex-direction: column;
        }
    }
}

.c-model-viewer {
    background: rgba(234, 227, 227, 0.693);
    width: 100%;
    // height: calc(60vh);
}

.ar-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
}

#ar-button {
    display: block;
    margin: auto;
    z-index: 999999;
    background: #fff !important;
    color: blue;
    font-size: 12px;
    padding: 10px 30px;
    border: 1px solid #fff;
    border-radius: 5px;
    box-shadow: 0 1px 1px #fff;
}

#ar-failure {
    position: relative;
    bottom: 50px;

    display: block;
    margin: auto;
    background: #fff !important;
    color: blue;
    font-size: 12px;
    padding: 10px 30px;
    border: 1px solid #fff;
    border-radius: 5px;
    box-shadow: 0 1px 1px #fff;
}

@media screen and (min-width: 350px) and (max-width: 470px) {
    .details-page-header-section {
        margin: 10px 0px !important;
        padding: 0px 30px !important;
        // background-color: rebeccapurple;
    }

    .details-page-middle-section {
        flex-direction: column;
        padding: 30px 30px !important;

        .bg-img {
            width: 370px !important;
            height: 450px !important;
        }

        .c-model-viewer {
            // width: 370px !important;
            // height: 450px !important;
            width: 100% !important;
            height: 270px !important;
            // background-color: rebeccapurple;
        }

        .bg-text-groups {
            flex-direction: column;
            // background-color: red;

            .bg-text {
                cursor: pointer;
                width: 80%;
                font-size: 1rem !important;
                margin: 10px 0px;
            }
        }
    }
}

@media screen and (min-width: 471px) and (max-width: 770px) {
    .details-page-header-section {
        margin: 10px 0px !important;
        padding: 0px 30px !important;
        // background-color: rebeccapurple;
    }

    .details-page-middle-section {
        flex-direction: column;
        padding: 30px 30px !important;

        .bg-img {
            width: 370px !important;
            height: 450px !important;
        }

        .c-model-viewer {
            // width: 370px !important;
            // height: 450px !important;
            width: 100% !important;
            height: 470px !important;
            // background-color: rebeccapurple;
        }

        .bg-text-groups {
            flex-direction: column;
            // background-color: red;

            .bg-text {
                cursor: pointer;
                width: 80%;
                font-size: 1rem !important;
                margin: 10px 0px;
            }
        }
    }
}

.vld-parent {
    position: absolute;
}

.vld-background {
    background: transparent !important;
    backdrop-filter: none !important;
}

.btn:focus {
    box-shadow: none !important;
}

.bg-venus {
    background-color: #807e7f !important;
}
</style>
